import {DocumentData, QueryDocumentSnapshot, SnapshotOptions, Timestamp} from "firebase/firestore";
import {LogisticsChangeLogType, LogisticsDriverChangeLogType} from "./LogisticsDriverChangeLogType";

function toNullableDate(value: Timestamp | null | undefined): Date | null {
    return value instanceof Timestamp ? value.toDate() : null;
}

function toDate(value: Timestamp | null | undefined): Date {
    return toNullableDate(value) ?? new Date(0);
}

function isChangeType(value: string): value is LogisticsChangeLogType {
    return value === "DRIVER" ||
        value === "TRUCK" ||
        value === "PLAN_START_DATE" ||
        value === "PLAN_END_DATE" ||
        value === "ROUTE" ||
        value === "EVENT_NUMBER" ||
        value === "DAY_TYPE" ||
        value === "REPORT_START_DATE" ||
        value === "REPORT_END_DATE" ||
        value === "START_KM" ||
        value === "END_KM" ||
        value === "REPORT_NOTES" ||
        value === "DELETE";
}

function toChangeType(value: string): LogisticsChangeLogType {
    return isChangeType(value) ? value : "DRIVER";
}

function legacyPreviousValue(data: DocumentData, changeType: LogisticsChangeLogType): string {
    if (changeType === "TRUCK") {
        return typeof data.previousTruckName === "string" ? data.previousTruckName : "";
    }

    return typeof data.previousDriverName === "string" ? data.previousDriverName : "";
}

function legacyNewValue(data: DocumentData, changeType: LogisticsChangeLogType): string {
    if (changeType === "TRUCK") {
        return typeof data.newTruckName === "string" ? data.newTruckName : "";
    }

    return typeof data.newDriverName === "string" ? data.newDriverName : "";
}

export const logisticsDriverChangeLogFBConverter = {
    fromFirestore: (
        snapshot: QueryDocumentSnapshot<DocumentData>,
        options: SnapshotOptions
    ): LogisticsDriverChangeLogType => {
        const data = snapshot.data(options);

        return {
            id: snapshot.id,
            changeType: toChangeType(typeof data.changeType === "string" ? data.changeType : ""),
            logisticId: typeof data.logisticId === "string" ? data.logisticId : "",
            eventNumber: typeof data.eventNumber === "string" ? data.eventNumber : "",
            periodStart: toNullableDate(data.periodStart),
            periodEnd: toNullableDate(data.periodEnd),
            previousValue: typeof data.previousValue === "string"
                ? data.previousValue
                : legacyPreviousValue(data, toChangeType(typeof data.changeType === "string" ? data.changeType : "")),
            newValue: typeof data.newValue === "string"
                ? data.newValue
                : legacyNewValue(data, toChangeType(typeof data.changeType === "string" ? data.changeType : "")),
            changedAt: toDate(data.changedAt),
            changedByEmployeeId: typeof data.changedByEmployeeId === "string" ? data.changedByEmployeeId : null,
            changedByName: typeof data.changedByName === "string" ? data.changedByName : ""
        };
    },
    toFirestore: (log: LogisticsDriverChangeLogType): DocumentData => ({
        changeType: log.changeType,
        logisticId: log.logisticId,
        eventNumber: log.eventNumber,
        periodStart: log.periodStart,
        periodEnd: log.periodEnd,
        previousValue: log.previousValue,
        newValue: log.newValue,
        changedAt: log.changedAt,
        changedByEmployeeId: log.changedByEmployeeId,
        changedByName: log.changedByName
    })
};
